import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import {
  ProfileDetailedView,
  CardSuggestion,
  ReportContainer
} from "../components";
import DecoratedHeading from "../../../components/common/DecoratedHeading";

import {
  DRIVER_SUGGESTIONS,
  LEASE_INFORMATION,
  VEHICLE_SUGGESTIONS
} from "../content";

import { NitroGrid, NitroGrids } from "nitro-components";

const ComponentContainer = styled.div`
  display: block;
`;

//TODO REMOVE IT ONCE WE HAVE SUGGESTIONS COMING FROM BE
const driverSuggestions = [
  {
    title: "Driver training program",
    content: "Driver has received an unusually high amount of infringements",
    icon: "driver-wheel"
  },
  {
    title: "Extending the lease terms",
    content: "Driver has excessive vehicle over utilisation. Extend the lease to help them get back on track.",
    icon: "lease-term"
  },
  {
    title: "Reducing fuel card limit",
    content: "Driver has consistently used less than what is budgeted.Save more on your fleet budget now!",
    icon: "fuel-pump"
  },
  {
    title: "Good driver rewards!",
    content: "This driver has not gotten any demerit points and has a consistent high safety rating.",
    icon: "winner"
  }
];

const vehicleSuggestions = [
  {
    title: "Extending the lease terms",
    content: "Driver has excessive vehicle over utilisation. Extend the lease to help them get back on track.",
    icon: "lease-term"
  },
  {
    title: "Reducing fuel card limit",
    content: "Driver has consistently used less than what is budgeted.Save more on your fleet budget now!",
    icon: "fuel-pump"
  }
];

const renderSuggestions = suggestions => (
  <ComponentContainer>
    <NitroGrids>
      {suggestions.map(function(suggestion, index) {
        return (
          <NitroGrid
            key={index}
            grid={3}
            transition
            transitionDelay={100 * index}
            transitionDuration={800}
          >

            <CardSuggestion
              title={suggestion.title}
              description={suggestion.content}
              icon={suggestion.icon}
            />
          </NitroGrid>
        );
      })}

    </NitroGrids>
  </ComponentContainer>
);

class DashboardProfileTab extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    return this.props.tabValue !== nextProps.tabValue;
  }

  componentWillUpdate(nextProps, nextState) {}

  render() {
    const { tabValue, reportHeading, dashboardType } = this.props;

    switch (tabValue) {
      case DRIVER_SUGGESTIONS:
        return renderSuggestions(driverSuggestions);
      case VEHICLE_SUGGESTIONS:
        return renderSuggestions(vehicleSuggestions);
      default:
        return (
          <ComponentContainer>
            <NitroGrids>
              {this.props.cards &&
                this.props.cards.map((card, index) => (
                  <ProfileDetailedView
                    {...card}
                    key={`card-${card.Title}`}
                    index={index}
                    companyCode={this.props.companyCode}
                    countryCode={this.props.countryCode}
                    driverId={this.props.driverId}
                    onCardClick={this.props.onCardClick}
                    leaseId={this.props.leaseId}
                    leaseData={this.props.leaseData}
                    showHistoryDetails={this.props.showHistoryDetails}
                  />
                ))}
            </NitroGrids>
            <DecoratedHeading
              label={reportHeading}
              variant="base3"
              marginBottom="50px"
              width="100%"
            />
            {this.props.reportCards &&
              <ReportContainer
                reports={this.props.reportCards}
                fetchReportDetail={this.props.openReportDetails}
                onClickNavigate={this.props.onNavigate}
                companyCode={this.props.companyCode}
                countryCode={this.props.countryCode}
                driverId={this.props.driverId}
                leaseId={this.props.leaseId}
                type={dashboardType}
              />}
          </ComponentContainer>
        );
    }
  }
}

DashboardProfileTab.propTypes = {
  cards: PropTypes.array,
  reportCards: PropTypes.array,
  tabValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  leaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  leaseData: PropTypes.object,
  onCardClick: PropTypes.func,
  companyCode: PropTypes.string,
  countryCode: PropTypes.string,
  driverId: PropTypes.string,
  onNavigate: PropTypes.func,
  openReportDetails: PropTypes.func,
  showHistoryDetails: PropTypes.func,
  reportHeading: PropTypes.string,
  dashboardType: PropTypes.string
};

DashboardProfileTab.defaultProps = {
  // defaultProp: ''
};

export default DashboardProfileTab;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/DashboardProfileTab.js